var _circle, _circle2, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTopnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12003_113131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12003_113131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7891 33.4271H61.1663C57.6154 27.6743 51.256 23.8408 43.9997 23.8408C32.8659 23.8408 23.8398 32.8669 23.8398 44.0007C23.8398 53.288 30.1202 61.107 38.6664 63.4458L46.7881 33.4271H55.7891Z",
    fill: "url(#paint0_linear_12003_113131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1601 44.0013C64.1601 40.1238 63.0635 36.5013 61.1669 33.4277H55.7897H46.7887L38.667 63.4464C40.3664 63.9112 42.1538 64.1611 44.0002 64.1611C55.134 64.1611 64.1601 55.135 64.1601 44.0013Z",
    fill: "url(#paint1_linear_12003_113131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2343 33.5374C60.4706 32.2826 59.5737 31.1182 58.5639 30.0631C58.3127 30.0053 58.0514 29.9727 57.7826 29.9727H36.7511C34.8431 29.9727 33.2969 31.5189 33.2969 33.4268C33.2969 35.3348 34.8431 36.881 36.7511 36.881H41.8858L37.5085 53.0579C36.9558 55.1002 38.1629 57.2041 40.2065 57.7568C40.5419 57.8472 40.8785 57.8912 41.2088 57.8912C42.897 57.8912 44.4432 56.767 44.9042 55.06L49.8229 36.8823H57.7838C59.6541 36.8823 61.1765 35.3951 61.2343 33.5374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9991 62.9327C54.4553 62.9327 62.9317 54.4563 62.9317 44C62.9317 33.5438 54.4553 25.0674 43.9991 25.0674C33.5428 25.0674 25.0664 33.5438 25.0664 44C25.0664 54.4563 33.5428 62.9327 43.9991 62.9327Z",
    fill: "url(#paint2_radial_12003_113131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12003_113131",
    x1: 38.0599,
    y1: 22.2134,
    x2: 47.599,
    y2: 60.3275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3618,
    stopColor: "#292D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4537,
    stopColor: "#2B3671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#2F4F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    stopColor: "#377891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40AAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12003_113131",
    x1: 51.6515,
    y1: 27.4952,
    x2: 51.3025,
    y2: 65.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#EA442A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5883,
    stopColor: "#F59326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#FCC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "#FFD723"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12003_113131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.8582 -22.6395 13.6699 13.805 28.5092 26.9389)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTopnet);
export default __webpack_public_path__ + "static/media/logoModalTopnet.19017c70042548fa9aee1032e26c7ee0.svg";
export { ForwardRef as ReactComponent };